// Custom DataTables sort type that always places blank/empty values last,
// regardless of whether the column is sorted ascending or descending.
$.fn.dataTable.ext.type.order['tags-asc'] = (a, b) => {
  if (a === b) return 0;
  if (a === '') return 1;
  if (b === '') return -1;
  return a < b ? -1 : 1;
};

$.fn.dataTable.ext.type.order['tags-desc'] = (a, b) => {
  if (a === b) return 0;
  if (a === '') return 1;
  if (b === '') return -1;
  return a > b ? -1 : 1;
};
